// extracted by mini-css-extract-plugin
export default {"emptyState":"TaskEmptyState_emptyState__I8B7Q"};